export enum SupportedChainId {
	MAINNET = 1,
	ROPSTEN = 3,
	RINKEBY = 4,
	KOVAN = 42,
	LOCALHOST = 1337,
}

export const ALL_SUPPORTED_CHAIN_IDS: SupportedChainId[] = [
	SupportedChainId.MAINNET,
	SupportedChainId.ROPSTEN,
	SupportedChainId.RINKEBY,
	SupportedChainId.KOVAN,
	SupportedChainId.LOCALHOST,
]

export interface L1ChainInfo {
	readonly blockWaitMsBeforeWarning?: number
	readonly explorer: string
	readonly infoLink: string
	readonly label: string
	readonly logoUrl?: string
	readonly rpcUrls?: string[]
	readonly nativeCurrency: {
		name: string // 'Goerli ETH',
		symbol: string // 'gorETH',
		decimals: number //18,
	}
}

export const CHAIN_INFO: {
	[chainId in SupportedChainId as number]: L1ChainInfo
} = {
	[SupportedChainId.MAINNET as number]: {
		explorer: 'https://etherscan.io/',
		infoLink: 'https://app.gnarlygoats.com/',
		label: 'Rinkeby',
		nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
	},
	[SupportedChainId.ROPSTEN as number]: {
		explorer: 'https://ropsten.etherscan.io/',
		infoLink: 'https://ropsten.gnarlygoats.com/',
		label: 'Rinkeby',
		nativeCurrency: { name: 'Ropsten ETH', symbol: 'ropETH', decimals: 18 },
	},
	[SupportedChainId.RINKEBY as number]: {
		explorer: 'https://rinkeby.etherscan.io/',
		infoLink: 'https://rinkeby.gnarlygoats.com/',
		label: 'Rinkeby',
		nativeCurrency: { name: 'Rinkeby ETH', symbol: 'rinkETH', decimals: 18 },
	},
	[SupportedChainId.KOVAN as number]: {
		explorer: 'https://kovan.etherscan.io/',
		infoLink: 'https://kovan.gnarlygoats.com/',
		label: 'Rinkeby',
		nativeCurrency: { name: 'Kovan ETH', symbol: 'kovETH', decimals: 18 },
	},
	[SupportedChainId.LOCALHOST as number]: {
		explorer: 'https://etherscan.io/',
		infoLink: 'https://mint.localhost:3000/',
		label: 'Ganache',
		nativeCurrency: { name: 'Ganache ETH', symbol: 'ganacheETH', decimals: 18 },
	},
}
